const owns = (row, key) => Object.prototype.hasOwnProperty.call(row, key);
const holder = item => owns(item, 'physicalHolderId') ? item.physicalHolderId
  : item.containedById || item.holderId || null;
const placed = item => ['physicalHolderId', 'containedById', 'holderId'].some(key => owns(item, key));
const loose = item => Boolean(item.looseLocation || item.location || item.loosePlaceId || item.ambiguousPlacement);
const container = item => Boolean(item?.idContainer || item?.container || item?.containerName || item?.itemType === 'Container');

// Character-sheet labels and content summaries follow current custody IDs.
// Historical display names/lists cannot override a later pickup or storage.
export const projectInventoryContainment = (items, actorId) => {
  const byId = new Map();
  const visit = rows => {
    for (const item of rows || []) {
      if (!item?.idEntity || byId.has(item.idEntity)) continue;
      byId.set(item.idEntity, item);
      visit(item.containedItems);
    }
  };
  visit(items);
  const childrenByHolder = new Map();
  for (const child of byId.values()) if (!loose(child) && holder(child) && holder(child) !== child.idEntity) {
    const parentId = holder(child);
    if (!childrenByHolder.has(parentId)) childrenByHolder.set(parentId, []);
    childrenByHolder.get(parentId).push(child);
  }
  return items.map(item => {
    if (!item) return item;
    const parentId = holder(item), parent = byId.get(parentId);
    const inside = !loose(item) && parentId !== item.idEntity && container(parent);
    const parentName = inside ? parent.name || parent.title || parent.containerName || parent.container || '' : '';
    const clearLabel = placed(item) && (loose(item) || !parentId || parentId === actorId
      || parentId !== item.containedById || parent && !container(parent));
    const children = new Map();
    for (const summary of [...(item.containsItems || []), ...(item.containedItems || [])]) {
      const child = byId.get(summary.idEntity) || summary;
      if (loose(child) || placed(child) && holder(child) !== item.idEntity) continue;
      children.set(child.idEntity || summary, { ...summary, ...child });
    }
    for (const child of childrenByHolder.get(item.idEntity) || []) children.set(child.idEntity, child);
    return { ...item, inventoryContainerLabel: parentName,
      ...(inside ? { containedById: parentId, containedByName: parentName, containedByTitle: parent.title || '' }
        : clearLabel ? { containedByName: '', containedByTitle: '' } : {}),
      ...(container(item) || item.containsItems || item.containedItems ? { containsItems: [...children.values()] } : {}) };
  });
};
